import { StyledLogo } from "./style";

const Logo = () => {
    return (
        <StyledLogo path="/">
            do<span>ar</span>
        </StyledLogo>
    );
};

export default Logo;
